import { render, staticRenderFns } from "./BaseVoting.vue?vue&type=template&id=7c8b9da0&scoped=true"
import script from "./BaseVoting.vue?vue&type=script&lang=js"
export * from "./BaseVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8b9da0",
  null
  
)

export default component.exports